import { Modal, Typography, Box, Button } from "@mui/material";
import { useState } from 'react';

export default function AssignmentModal(props) {
  const { closeModal, modalTitle, modalMessage } = props;
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    closeModal();
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        maxWidth: '90%',
        maxHeight: '90%',
        overflow: 'auto',
        borderRadius: '16px'
      }}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {modalTitle}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {modalMessage}
        </Typography>
        <Button sx={{ mt: 2 }} onClick={handleClose}>Close</Button>
      </Box>
    </Modal>
  );
}